// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-row-loading[data-v-317f85eb] {\n  width: 30%;\n  min-width: 44px;\n  height: 14px;\n  border-radius: 999px;\n  background-color: var(--superficie-sutil);\n}\n.conteudo-numerico[data-v-317f85eb] {\n  font-variant-numeric: tabular-nums;\n  justify-self: end;\n  text-align: right;\n  width: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
